import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';
import { triggerAuthLogout } from 'providers/authLogoutTrigger';

export class CheckrApiClient {
  instance: AxiosInstance;

  constructor() {
    this.instance = axios.create();
    this.instance.interceptors.response.use(
      res => res,
      this.responseErrorHandler,
    );
  }

  responseErrorHandler(error: AxiosError) {
    const data = error.response?.data as { auth_mode?: string } | undefined;
    if (error.response?.status === 401 && !data?.auth_mode) {
      triggerAuthLogout();
    }
    return Promise.reject(error);
  }

  get<T>(url: string, params: AxiosRequestConfig = {}) {
    return this.instance.get<T>(url, params);
  }

  patch(url: string, data: any = {}) {
    return this.instance.patch(url, data);
  }

  post<T>(url: string, data: any, config?: object) {
    return this.instance.post<T>(url, data, config);
  }

  setAuthToken(token: string) {
    this.instance.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
}

export default new CheckrApiClient();
